export const INVALID_PASSWORD_HEADER = "Please enter validate new Password";

export const INVALID_PASSWORD_TEXT = "To continue, please follow the password rules";

export const CHANGE_PASSWORD_PAGE_TITLE = "Change Password";

export const CURRENT_PASSWORD_TITLE = "Current Password";

export const NEW_PASSWORD_TITLE = "New Password";

export const CONFIRM_PASSWORD_TITLE = "Confirm Password";

export const VALIDATION_PASSWORD_TITLE = "Password Must Contain";

export const CHECK_MARK_ICON_SCALE = 1.5;

export const CHANGE_PASSWORD_SUBMIT_TEXT = "Update Password";

export const CURRENT_PASSWORD_INPUT_NAME = "currentPassword";

export const NEW_PASSWORD_INPUT_NAME = "newPassword";

export const CONFIRM_PASSWORD_INPUT_NAME = "confirmPassword";